import { useEffect, useState } from "react";

/**
 * Hook SSR-safe para observar una media query de CSS.
 *
 * - En servidor / antes del primer commit del effect retorna `false` para
 *   evitar mismatch de hidratación (el primer paint siempre asume
 *   el lado "no móvil").
 * - Tras montar, sincroniza con `matchMedia` y se suscribe a cambios.
 *
 * @example
 *   const isMobile = useMediaQuery("(max-width: 640px)");
 */
export function useMediaQuery(query: string): boolean {
  const [matches, setMatches] = useState(false);

  useEffect(() => {
    if (typeof window === "undefined" || !window.matchMedia) {
      return;
    }

    const mql = window.matchMedia(query);
    const onChange = () => setMatches(mql.matches);

    onChange();
    mql.addEventListener("change", onChange);
    return () => mql.removeEventListener("change", onChange);
  }, [query]);

  return matches;
}